export default __webpack_public_path__ + "static/media/marke_2.f7ee6d51.png";